import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackButtonComponent } from './feedback-button.component';
import { ExitIntentGuardComponent } from './exit-intent-guard.component';
import { HotjarService } from './hotjar.service';

@NgModule({
  declarations: [
    FeedbackButtonComponent,
    ExitIntentGuardComponent
  ],
  imports: [CommonModule],
  exports: [
    FeedbackButtonComponent,
    ExitIntentGuardComponent
  ],
  providers: [
    HotjarService
  ]
})
export class SharedModule {} 


// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts